import { InjectionToken, Signal } from '@angular/core';
import { Source81 } from 'analytic-events/MI/services/BannerWidgetService/events/Source81';

export const MI_BANNER_ANALYTICS_SOURCE: InjectionToken<Signal<Source81>> = new InjectionToken<Signal<Source81>>(
  'MI_BANNER_ANALYTICS_SOURCE'
);
